<template>
	<f7-tab id="flow-classic" :tab-active="flow === CreatePaymentFlow.classic">
		<div
			v-if="warningClassicBlocks.length"
			class="new-payment-view__warning"
		>
			<FirebaseBlockWarning
				v-for="(block, index) in warningClassicBlocks"
				:key="index"
				:loading="!account"
				:message="block"
			/>
		</div>
		<ViewPaymentConfigAgentButton
			v-if="isCanSelectAgent && currency"
			@toSelectAgent="onOpenSelectAgentPopup"
			:agent="agent"
			:currency="currency"
		/>
		<PaymentInputAmount />
		<div class="default-amounts block">
			<DefaultAmountButton
				v-for="amount in suggestedAmounts"
				:key="amount"
				:amount="amount"
				:currency="currency.name"
				@click="handleClickDefaultAmount(amount)"
				@mousedown="defaultAmountStartEvent"
				@touchstart="defaultAmountStartEvent"
			/>
		</div>
	</f7-tab>
</template>

<script setup lang="ts">
import NewPaymentController, { CreatePaymentFlow } from "@/views/payment-create-config/NewPaymentController";
import FirebaseBlockWarning from "@components/atomic/block-warning/FirebaseBlockWarning.vue";
import ViewPaymentConfigAgentButton from "./ViewPaymentCreateConfigAgentButton.vue";
import PaymentInputAmount from "@/views/payment-create-config/comps/PaymentInputAmount.vue";
import DefaultAmountButton from "@components/ui/default-amount-button/DefaultAmountButton.vue";
import {computed} from "vue";
import {getDevice} from "framework7/shared/get-device";

const viewController = NewPaymentController.getInstance();

const {
	amount,
	currency,
	agent,
	isCanSelectAgent,
	flow,
	account,
	warningClassicBlocks,
	routerService,
	isUpdatingValueInput,
	inputAmountFocused,
	textMaxMinError
} = viewController;

const suggestedAmounts = computed(() => {
	return account.value?.currency.dSums ?? [1500, 3000, 5000, 7000];
});

const onOpenSelectAgentPopup = async () => {
	closeKeyboardFocusInput(async () => {
		textMaxMinError.value = false;
		await routerService.toViewPaymentCreateAgents();
	});
}

const closeKeyboardFocusInput = (callback: Function) => {
	if (getDevice().cordova && inputAmountFocused) {
		inputAmountFocused.value = false;
		setTimeout(async () => {
			await callback();
		}, 500);
		return false;
	}
	callback();
}

const handleClickDefaultAmount = (value: number) => {
	textMaxMinError.value = false
	isUpdatingValueInput.value = true
	amount.value = value;
	setTimeout(() => {
		isUpdatingValueInput.value = false
	}, 0)
}

const defaultAmountStartEvent = () => {
	isUpdatingValueInput.value = true;
}
</script>
